import { Component, OnInit } from '@angular/core';
import { CommonUtil, LoginService } from '@serengeti/serengeti-common';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '@serengeti/serengeti-notification';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-home-logout',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeLogoutComponent implements OnInit {

    loginId: string;
    loginName: string;
    isKeycloakUsed: boolean;
    returnUrl: string;
    keycloakEndPoint: string;
    keycloakLogoutEndpoint: string;

    profile = environment.profile;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private loginService: LoginService,
        private notificationService: NotificationService
    ) {
        this.isKeycloakUsed = localStorage.getItem("isKeycloakUsed") === "true";
        this.keycloakEndPoint = environment.serviceKeycloakEndPoint;
        this.keycloakLogoutEndpoint = environment.serviceKeycloakLogoutEndpoint;
    }

    ngOnInit() {
        this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/';

        if (this.notificationService.connected) {
            this.notificationService.disconnect();
        }
        if (this.loginService.getLoginId()) {

            this.loginService.logout(false, this.isKeycloakUsed);

            // keycloak 설정 및 keycloak logout endpoint 지정되어 있을 시 해당 url로 redirect 진행
            if (this.isKeycloakUsed && this.keycloakLogoutEndpoint.trim() !== '') {
                window.location.href = this.keycloakLogoutEndpoint;
            } else {
                this.router.navigate(['/home']);
            }
        }
    }

    public ssoLogin() {
        const redirectUri = `${window.location.protocol}//${window.location.host}/ssosignin`;
        window.location.href = CommonUtil.buildEndPoint(this.keycloakEndPoint, "user/auth") + "?redirect_uri=" + encodeURIComponent(redirectUri);
    }
}


